import React, { useEffect } from 'react';
import axios from 'axios';
import Grid from '@mui/material/Unstable_Grid2';

import ColorSwatches from '../components/color-swatches'
import CarModelSelector from '../components/car-model-selector'
import CarModifiedSelector from '../components/car-modified-selector';
import InfoTabs from '../components/info-tabs';
import CartButtons from '../components/cart-buttons';
import ProductInfo from '../components/product-info';
import EmbroiderySelector from '../components/embroidery-selector';
import { useCarCoverStore } from '../stores/car-cover-store';
import { PRODUCTS_MAP, PRODUCTS_TYPES_MAP } from '../constants/product';
import CarCoverImages from '../components/car-cover-images';
import { formatMoney, generateHash } from '../utils/helpers';
import FlannelLiningSelector from '../components/flannel-lining-selector';
import NoLogoSelector from '../components/no-logo-selector';

function CarCovers() {
  const selectedCar = useCarCoverStore(state => state.selectedCar);
  const setSelectedCar = useCarCoverStore(state => state.setSelectedCar);
  const selectedColor = useCarCoverStore(state => state.selectedColor);
  const setSelectedColor = useCarCoverStore(state => state.setSelectedColor);
  const selectedSecondaryColor = useCarCoverStore(state => state.selectedSecondaryColor);
  const setSelectedSecondaryColor = useCarCoverStore(state => state.setSelectedSecondaryColor);
  const productVariant = useCarCoverStore(state => state.productVariant);
  const setProductVariant = useCarCoverStore(state => state.setProductVariant);
  const selectedPipingProductVariant = useCarCoverStore(state => state.selectedPipingProductVariant);
  const embroideryProductVariants = useCarCoverStore(state => state.embroideryProductVariants);
  const hasNoLogo = useCarCoverStore(state => state.hasNoLogo);
  const noLogoProductVariant = useCarCoverStore(state => state.noLogoProductVariant);
  const setHasNoLogo = useCarCoverStore(state => state.setHasNoLogo);
  const hasEmbroidery = useCarCoverStore(state => state.hasEmbroidery);
  const setHasEmbroidery = useCarCoverStore(state => state.setHasEmbroidery);
  const embroideryText = useCarCoverStore(state => state.embroideryText);
  const setEmbroideryText = useCarCoverStore(state => state.setEmbroideryText);
  const flannelLiningProductVariant = useCarCoverStore(state => state.flannelLiningProductVariant);
  const hasFlannelLining = useCarCoverStore(state => state.hasFlannelLining);
  const setHasFlannelLining = useCarCoverStore(state => state.setHasFlannelLining);
  const embroideryColors = useCarCoverStore(state => state.embroideryColors);
  const embroideryColor = useCarCoverStore(state => state.embroideryColor);
  const setEmbroideryColor = useCarCoverStore(state => state.setEmbroideryColor);
  const quantity = useCarCoverStore(state => state.quantity);
  const setQuantity = useCarCoverStore(state => state.setQuantity);
  const colorGroup = useCarCoverStore(state => state.colorGroup);
  const productImageHandle = useCarCoverStore(state => state.productImageHandle);
  const hasModification = useCarCoverStore(state => state.hasModification);
  const setHasModification = useCarCoverStore(state => state.setHasModification);
  const modificationText = useCarCoverStore(state => state.modificationText);
  const setModificationText = useCarCoverStore(state => state.setModificationText);
  const tabs = useCarCoverStore(state => state.tabs);

  const addToCart = async () => {
    console.log('addToCart selectedCar', selectedCar);
    if (hasEmbroidery === 'YES' && embroideryText === '') {
      return;
    }

    if (productVariant?.id && quantity > 0) {
      console.log('productVariant', productVariant);
      const car = `${selectedCar.year} ${selectedCar.make} ${selectedCar.model} ${selectedCar.submodel?.trim}`;
      let items = [];
      let item = {
        id: productVariant.id,
        quantity,
        properties: {
          Car: car,
          Make: selectedCar.make,
          Model: selectedCar.model,
          Trim: selectedCar.submodel?.trim,
          Logo: hasNoLogo === 'NO',
          car_notes: selectedCar.submodel?.notes,
          modifications: modificationText,
          modified: hasModification === 'YES',
          _part_number: selectedCar.submodel?.part_number,
        }
      }

      if (!!selectedSecondaryColor?.name && selectedSecondaryColor.name !== 'None') {
        const pipingColor = selectedSecondaryColor.name;
        const pipingHash = generateHash();
        const pipingQuantity = parseInt(quantity);

        // set item piping properties
        item.properties.pipingColor = pipingColor;
        item.properties._pipingHash = pipingHash;

        const pipingItem = {
          id: selectedPipingProductVariant?.id,
          quantity: pipingQuantity.toString(),
          properties: {
            Car: car,
            pipingColor,
            _pipingHash: pipingHash
          }
        }

        items.push(pipingItem);
      }

      if (hasEmbroidery === 'YES') {
        const embroideryTextTrimmed = embroideryText.trim();
        const embroideryHash = generateHash();
        const embroideryTextFirst7 = embroideryTextTrimmed
          .replace(/ /g, "")
          .slice(0, 7);
        const embroideryTextAdditional = embroideryTextTrimmed
          .replace(/ /g, "")
          .slice(7, embroideryText.length);
        const embroideryQuantity = parseInt(quantity);
        const additionalEmbroideryQuantity = (embroideryTextAdditional.length * embroideryQuantity).toString();

        // set item embroidery properties
        item.addEmbroidery = hasEmbroidery === 'YES';
        item.embroideryColor = embroideryColor.name;
        item.properties._embroideryHash = embroideryHash;
        item.properties.embroideryText = embroideryText;
        item.properties.embroideryThreadColor = embroideryColor.name;

        const embroideryItem = {
          id: embroideryProductVariants.default.id,
          quantity: embroideryQuantity.toString(),
          properties: {
            Car: car,
            embroideryTextFirst7Characters: embroideryTextFirst7,
            embroideryThreadColor: embroideryColor.name,
            _embroideryHash: embroideryHash
          }
        }
        const embroideryAdditionalItem = {
          id: embroideryProductVariants.additional.id,
          quantity: additionalEmbroideryQuantity,
          properties: {
            Car: car,
            embroideryTextAdditionalCharacters: embroideryTextAdditional,
            embroideryThreadColor: embroideryColor.name,
            _embroideryQtyPerItem: additionalEmbroideryQuantity,
            _embroideryHash: embroideryHash
          }
        }

        items.push(embroideryItem);
        items.push(embroideryAdditionalItem);
      }

      if (hasFlannelLining === 'YES') {
        const fltsHash = generateHash();
        const fltsQuantity = parseInt(quantity);

        // set item flannel lining properties
        item.properties._fltsHash = fltsHash;

        const fltsItem = {
          id: flannelLiningProductVariant.id,
          quantity: fltsQuantity.toString(),
          properties: {
            Car: car,
            _fltsHash: fltsHash
          }
        }

        items.push(fltsItem);
      }

      if (hasNoLogo === 'YES') {
        const removeBhmaLogoHash = generateHash();
        const removeBhmaLogoQuantity = parseInt(quantity);

        // set item no logo properties
        item.properties._removeBhmaLogoHash = removeBhmaLogoHash;

        const removeBhmaLogoItem = {
          id: noLogoProductVariant.id,
          quantity: removeBhmaLogoQuantity.toString(),
          properties: {
            Car: car,
            _removeBhmaLogoHash: removeBhmaLogoHash
          }
        }

        items.push(removeBhmaLogoItem);
      }

      items.push(item);

      console.log('items', items);

      const { data } = await axios.post('/cart/add.js', {
        items
      });

      console.log('addToCart data', data);

      window.location.href = encodeURI('/cart');
    }
  }

  const getVariantForOptions = () => {
    const submodel = selectedCar?.submodel;
    const sizeCode = submodel?.size_code;

    if (sizeCode) {
      let variants = window?.conspire_product?.variants || [];
      let selectedVariant = {};

      if (window?.conspire_product?.handle === PRODUCTS_MAP['flannelguard-supreme']?.handle) {
        selectedVariant = variants?.find(
          v => v.option1 === selectedColor.name && v.option2 === sizeCode
        );
      } else {
        selectedVariant = variants.find(
          v => v.option1 === sizeCode && v.option2.toLowerCase() === selectedColor.name.toLowerCase()
        );
      }

      console.log('selectedVariant', selectedVariant);
      setProductVariant(selectedVariant)
    } else {
      setProductVariant({})
    }
  }

  useEffect(() => {
    getVariantForOptions();
  }, [selectedCar.submodel, selectedColor, selectedSecondaryColor]);

  const pipingCost = selectedPipingProductVariant?.option1 !== 'None' ? (
    <h3 className='piping-cost'>{formatMoney(selectedPipingProductVariant?.price / 100)}+</h3>
  ) : null;

  return (
    <Grid container>
      <Grid item xs={12} md={8} className="mobile-hide">
        <section className="main-image-container">
          <CarCoverImages
            selectedColor={selectedColor}
            selectedSecondaryColor={selectedSecondaryColor}
            imageHandle={productImageHandle}
          />
        </section>
        <InfoTabs tabs={tabs} />
      </Grid>
      <Grid item xs={12} md={4}>
        <ProductInfo />
        <section className="main-image-container desktop-hide">
          <CarCoverImages
            selectedColor={selectedColor}
            selectedSecondaryColor={selectedSecondaryColor}
            imageHandle={productImageHandle}
          />
        </section>
        <CarModelSelector
          product={PRODUCTS_TYPES_MAP.CAR_COVERS}
          selectedCar={selectedCar}
          setSelectedCar={setSelectedCar}
          productVariant={productVariant}
        />
        <ColorSwatches
          title="Colors"
          selectedColor={selectedColor}
          setSelectedColor={setSelectedColor}
          colors={colorGroup.colors}
          showSelectedColor
        />
        {window?.conspire_product?.handle === PRODUCTS_MAP['flannelguard-supreme']?.handle && (
          <>
            <ColorSwatches
              title="Piping"
              selectedColor={selectedSecondaryColor}
              setSelectedColor={setSelectedSecondaryColor}
              colors={colorGroup.secondaryColors}
              showSelectedColor
            />
            {pipingCost}
          </>
        )}
        {window?.conspire_product?.handle === PRODUCTS_MAP['ultraguard']?.handle && (
          <FlannelLiningSelector
            title="WOULD YOU LIKE TO ADD FLANNEL LINING TO SEAMS?"
            price="+$75.00"
            hasFlannelLining={hasFlannelLining}
            setHasFlannelLining={setHasFlannelLining}
          />
        )}
        <EmbroiderySelector
          title="WOULD YOU LIKE TO ADD EMBROIDERY?"
          price="$25.00+"
          hasEmbroidery={hasEmbroidery}
          setHasEmbroidery={setHasEmbroidery}
          embroideryColors={embroideryColors}
          embroideryColor={embroideryColor}
          setEmbroideryColor={setEmbroideryColor}
          embroideryText={embroideryText}
          setEmbroideryText={setEmbroideryText}
        />
        <NoLogoSelector
          title="WOULD YOU LIKE TO REMOVE OUR BHMA LOGO?"
          description="All car covers have our BHMA logo unless otherwise specified. This helps locate the front of the cover."
          hasNoLogo={hasNoLogo}
          setHasNoLogo={setHasNoLogo}
        />
        <CarModifiedSelector
          hasModification={hasModification}
          setHasModification={setHasModification}
          modificationText={modificationText}
          setModificationText={setModificationText}
        />
        <CartButtons addToCart={addToCart} quantity={quantity} setQuantity={setQuantity} />
        <section className="info-tabs-wrapper desktop-hide">
          <InfoTabs tabs={tabs} />
        </section>
      </Grid>
    </Grid>
  )
}

export default CarCovers
